<div class="container-fluid mt-4">

  <!-- Add Part Button -->
  <button class="btn btn-primary mb-3" (click)="openModal(addPartModal)">+ ახალი ნაწილი</button>

  <!-- Category Filter -->
<div class="form-floating mb-3">
  <select class="form-select" [(ngModel)]="selectedCategory" (change)="filterByCategory()">
    <option value="" selected>ყველა კატეგორია</option>
    <option *ngFor="let cat of categories" [value]="cat.id">
      {{ cat.name }}
    </option>
  </select>
  <label>კატეგორია</label>
</div>
<!-- Search Filter -->
<div class="input-group mb-3">
  <span class="input-group-text"><i class="fi fi-rr-search"></i></span>
  <input
    type="text"
    class="form-control"
    placeholder="ძიება: დასახელება, code, oem..."
    [(ngModel)]="searchTerm"
    (ngModelChange)="onSearchChange()"
  />
  <button class="btn btn-outline-secondary" type="button" (click)="clearSearch()" [disabled]="!searchTerm">
    გასუფთავება
  </button>
</div>



<div class="parts-list" cdkDropList (cdkDropListDropped)="drop($event)">
  <div *ngFor="let item of filteredData" class="card p-2 mb-2 shadow-sm" cdkDrag>
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex">
        <img [src]="getImages(item.folder, item.image)" [attr.loading]="'lazy'" width="50" class="me-2">
        <div class="mx-2">
          <p>{{ item.title_ka }}</p>
          <p>{{ item?.car?.name }}</p>
          <span class="text-muted ms-2">{{ item.price }} ₾</span>
        </div>
      </div>
      <div class="d-flex">
        <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="editPart(item, addPartModal)">
          <i class="fi fi-rr-pencil"></i>
        </button> 
        <button class="btn btn-sm text-danger border rounded d-flex align-items-center mx-2" (click)="deletePart(item.id)">
          <i class="fi fi-rr-trash"></i>
        </button> 
      </div>
    </div>
  </div>
</div>

<app-spinner [loading]="load"></app-spinner>

<div class="text-center my-3" *ngIf="page < lastPage">
  <button class="btn btn-primary" (click)="loadMore()" [disabled]="load">
    {{ load ? 'იტვირთება...' : 'მეტის ჩატვირთვა' }}
  </button>
</div>



</div>

<!-- Add Part Modal -->
<ng-template #addPartModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">ნაწილის დამატება</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <form [formGroup]="partForm" (ngSubmit)="savePart(modal)">
    <div class="modal-body">

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="title_ka" formControlName="title_ka" placeholder="Title (KA)">
        <label for="title_ka">დასახელება (KA)</label>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="title_en" formControlName="title_en" placeholder="Title (EN)">
        <label for="title_en">დასახელება (EN)</label>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="title_ru" formControlName="title_ru" placeholder="Title (RU)">
        <label for="title_ru">დასახელება (RU)</label>
      </div>

      <div class="mb-3">
          <label for="description_ka">აღწერა (KA)</label>
          <editor
            [init]="{
              base_url: '/tinymce',
              license_key: 'gpl',
              suffix: '.min',
              plugins: 'link image fullscreen',
              toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist |  fullscreen',
            }"
            formControlName="description_ka"
          ></editor>
        </div>

        <div class="mb-3">
          <label for="description_en">აღწერა (EN)</label>
          <editor
            [init]="{
              base_url: '/tinymce',
              license_key: 'gpl',
              suffix: '.min',
              plugins: 'link image fullscreen',
              toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist |  fullscreen',
            }"
            formControlName="description_en"
          ></editor>
        </div>

        <div class="mb-3">
          <label for="description_ru">აღწერა (RU)</label>
          <editor
            [init]="{
              base_url: '/tinymce',
              license_key: 'gpl',
              suffix: '.min',
              plugins: 'link image fullscreen',
              toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist |  fullscreen',
            }"
            formControlName="description_ru"
          ></editor>
        </div>

      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="price" formControlName="price" placeholder="Price">
        <label for="price">ფასი</label>
      </div>

      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="newprice" formControlName="newprice" placeholder="newprice">
        <label for="newprice">ფასდაკლების ფასი</label>
      </div>

      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="stock" formControlName="stock" placeholder="Stock">
        <label for="stock">მარაგი</label>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="numbersy" formControlName="numbersy" placeholder="Numbersy">
        <label for="numbersy">Numbersy</label>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="oem" formControlName="oem" placeholder="oem">
        <label for="oem">oem</label>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="code" formControlName="code" placeholder="code">
        <label for="code">code</label>
      </div>

      <div class="form-floating mb-3">
        <select class="form-select" id="catid" formControlName="catid">
          <option value="" disabled selected>აირჩიეთ კატეგორია</option>
          <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.name }}</option>
        </select>
        <label for="catid">კატეგორია</label>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="compatible_with" formControlName="compatible_with" placeholder="მორგებადი მოდელები">
        <label for="compatible_with">მორგებადი მოდელები</label>
      </div>

      <img *ngIf="partForm.get('image').value" src="{{url}}/parts/{{partForm.get('folder').value}}/{{partForm.get('image').value}}">


      <div class="form-floating mt-3">
              <app-upload
              [uploadPath]="getUploadPatch(partForm.get('folder').value)"
              (fileUploaded)="onFileUploaded($event)"
             >
            </app-upload>   
          </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
      <button type="submit" class="btn btn-success">შენახვა</button>
    </div>
  </form>
</ng-template>